export default "__VITE_ASSET__d225f8cf__"